import React, { useContext } from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';
import noop from 'utils/noop';

import { useKountSessionId } from './use-kount-session-id';

export interface IFraudPreventionContext {
  kountSessionId: string;
  resetKountSessionId(): void;
}

export const FraudPreventionContext = React.createContext({
  kountSessionId: '',
  resetKountSessionId: noop
} as IFraudPreventionContext);
export const useFraudPreventionContext = () => useContext(FraudPreventionContext);

export function FraudPreventionProvider(props: IBaseProps) {
  const { kountSessionId, resetKountSessionId } = useKountSessionId();

  return (
    <FraudPreventionContext.Provider value={{ kountSessionId, resetKountSessionId }}>
      {props.children}
    </FraudPreventionContext.Provider>
  );
}

export default FraudPreventionContext.Consumer;
